
export const Types = {
    OPEN_PRIMARY_CONTACTS_MODAL: "OPEN_PRIMARY_CONTACTS_MODAL",
    ADD_PRIMARY_CONTACT: "ADD_PRIMARY_CONTACT",
    CLEAR_PRIMARY_CONTACTS_STATES: "CLEAR_PRIMARY_CONTACTS_STATES",
  };